import { Menu, MenuItem } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { fetchLogout, selectUser } from '../../../../store/user/userSlice';
import { useAppDispatch } from '../../../../../reduxService/hooks';

interface IUserButtonProps {}

const UserButton = (props: IUserButtonProps) => {
    const { t, i18n } = useTranslation();

    const user = useSelector(selectUser);
    const dispatch = useAppDispatch();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(e.currentTarget);
    };

    const handleLogout = () => {
        dispatch(fetchLogout());
    };

    return (
        <>
            <button type='button' className='btn' onClick={handleClick}>
                <i className='fa-regular fa-user' />
                {user.data!.firstName + ' ' + user.data!.lastName}
                <i className='fa-solid fa-angle-down' />
            </button>
            <Menu
                id='basic-menu-save'
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}>
                <MenuItem onClick={handleLogout}>{t('header_user_button_logout')}</MenuItem>
            </Menu>
        </>
    );
};

export default UserButton;
